import { MTX_DRAWER_DATA, MtxDrawerRef } from '@ng-matero/extensions/drawer';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { LoggerService } from '@app/shared/services/logger.service';
import { BannerNotificationsService } from '@app/shared/services/banner-notifications.service';
import { UnknownShipmentsService } from '@app/shared/services/unknown-shipments.service';

@Component({
  standalone: false,
  selector: 'app-unknown-tracking-notes',
  templateUrl: './unknown-tracking-notes.component.html',
})
export class UnknownTrackingNotesComponent implements OnInit {
  public unknownShipment: any;
  public form: FormGroup;
  public saving: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private logger: LoggerService,
    private bannerNotificationsService: BannerNotificationsService,
    private unknownShipmentsService: UnknownShipmentsService,
    public drawerRef: MtxDrawerRef<UnknownTrackingNotesComponent>,
    @Inject(MTX_DRAWER_DATA)
    public data: {
      unknownShipment: any;
    }
  ) {}

  ngOnInit() {
    if (this.data && this.data.unknownShipment) {
      this.unknownShipment = this.data.unknownShipment;
      this.createForm();
    } else {
      this.dismissDrawer();
    }
  }

  private createForm() {
    this.form = this.formBuilder.group({
      note: [_.get(this.unknownShipment, 'notes', '') || '', Validators.maxLength(2000)],
    });
  }

  public submitForm() {
    if (this.saving) return;

    const noteValue = (this.form.get('note').value || '').trim();
    if (noteValue === (this.unknownShipment.notes || '')) {
      this.dismissDrawer(false);
      return;
    }

    this.saving = true;
    this.unknownShipmentsService.updateNotes(this.unknownShipment.id, noteValue).subscribe(
      (updated: any) => {
        this.unknownShipment.notes = updated?.notes ?? noteValue;
        this.saving = false;
        this.bannerNotificationsService.success('Notes saved successfully');
        this.logger.log('Update unknown tracking note success', updated);
        this.dismissDrawer(true);
      },
      (err) => {
        this.saving = false;
        this.bannerNotificationsService.error('Notes could not be saved');
        this.logger.error('Update unknown tracking note error', err);
      }
    );
  }

  public dismissDrawer(successful: boolean = false): void {
    this.drawerRef.dismiss(successful);
  }
}
